import { NgxMatDateFormats } from '@angular-material-components/datetime-picker';

/* eslint-disable @typescript-eslint/naming-convention */
const dateTimeFormat = (): string =>{
  const userPreference = JSON.parse(localStorage.getItem('user_preferences'));
  const date = userPreference && userPreference.date_format ? userPreference.date_format : 'DD/MM/YYYY';
  const userTimeFormat =  userPreference && userPreference.time_format ? userPreference.time_format : '12_HRS';
  const timeFormat = {
  '12_HRS' : 'hh:mm A',
  '24_HRS' : 'HH:mm'
  };
  return `${date} ${timeFormat[userTimeFormat]}`;
};
const dateFormat = (): string =>{
  const userPreference = JSON.parse(localStorage.getItem('user_preferences'));
  const date = userPreference && userPreference.date_format ? userPreference.date_format : 'DD/MM/YYYY';
  return `${date}`;
};
export const MY_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: dateTimeFormat(),
  },
  display: {
    dateInput: dateTimeFormat(),
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export const MAT_DATEPICKER_FORMATS = {
  parse: {
      dateInput: dateFormat(),
  },
  display: {
      dateInput: dateFormat(),
      monthYearLabel: 'YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'YYYY'
  }
};
